<template>
  <div :class="['task-card', { active: active }]" @click.stop="$emit('view', data.id)">
    <div class="task-card-inner">
      <div class="task-card-text">
        {{ data.textIn.substring(0, 150) }}
      </div>

      <div v-if="data.message" class="task-card-comment">
        {{ `Comment: ${data.message}` }}
      </div>

      <div class="task-card-info">
        <div class="task-card-date">
          <f7-icon f7="time" color="orange" size="18"></f7-icon>
          {{ data.createdAt }}
        </div>

        <!-- <div class="task-card-info-type">
          {{
            `${data.type[0].toUpperCase()}${data.type.slice(1).toLowerCase()}: ${
              languageIn.name
            } - ${languageOut.name}`
          }}
        </div> -->
      </div>

      <div class="task-card-action">
        <div class="task-card-characters">
          {{ `${data.textIn.length} characters` }}
        </div>
        <f7-button v-if="withAction" fill round color="green" @click.stop="$emit('take', data.id)">
          <div v-if="takeLoading" class="padding-horizontal">
            <f7-preloader style="margin-top: -2px;" size="18" color="white"></f7-preloader>
          </div>
          <span v-else>
            Take to work
          </span>
        </f7-button>

        <div v-if="withStatus" :class="['status', data.status]">
          Status:
          <span>
            {{ `${data.status[0].toUpperCase()}${data.status.slice(1).toLowerCase()}` }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskCard',
  props: {
    data: {
      type: Object,
      required: true
    },

    active: {
      type: Boolean,
      default: false
    },

    takeLoading: {
      type: Boolean,
      default: false
    },

    withAction: {
      type: Boolean,
      default: true
    },

    withStatus: {
      type: Boolean,
      default: false
    },

    languageIn: {
      type: Object,
      required: true
    },

    languageOut: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.task-card {
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.08);
  }

  &.active {
    border: 1px solid #ff6189;
  }

  &:not(:last-of-type) {
    margin-bottom: 15px;
  }

  .status {
    &.WORK {
      span {
        color: #ff001f;
      }
    }

    &.DONE {
      span {
        color: #4cd964;
      }
    }
  }
}

.task-card-inner {
  padding: 15px 10px;
}

.task-card-text {
  font-weight: 600;
  font-size: 12px;
  color: #000000;
  letter-spacing: -0.4px;
  word-wrap: break-word;
}

.task-card-comment {
  margin-top: 5px;
  font-size: 12px;
  color: #878787;
  letter-spacing: -0.4px;
  font-weight: 600;
  word-wrap: break-word;
}

.task-card-info {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.task-card-date {
  font-weight: 600;
  font-size: 12px;
  color: #878787;
  letter-spacing: -0.4px;

  .icon {
    margin-right: 5px;
  }
}

.task-card-info-type {
  font-weight: 700;
  font-size: 14px;
  color: #000000;
  letter-spacing: -0.47px;
  margin-left: 15px;
}

.task-card-action {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
